import { render, staticRenderFns } from "./ForceNewPasswordModal.vue?vue&type=template&id=1b95bc7c&scoped=true"
import script from "./ForceNewPasswordModal.vue?vue&type=script&lang=js"
export * from "./ForceNewPasswordModal.vue?vue&type=script&lang=js"
import style0 from "./ForceNewPasswordModal.vue?vue&type=style&index=0&id=1b95bc7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b95bc7c",
  null
  
)

export default component.exports